import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchWebinarsContent } from "../APIClient/apiClient";

export function useWebinarsContent() {
  const { currentLanguage, changeLanguage } = useTranslation();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [items, setItems] = useState([]);
  const [headerTexts, setHeaderTexts] = useState([]);

  useEffect(() => {
    let isActive = true;

    setTitle("");
    setDescription("");
    setMetaTitle("");
    setItems([]);
    setHeaderTexts([]);

    fetchWebinarsContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }
      if (data) {
        setTitle(data.title || "");
        setDescription(data.description || "");
        setMetaTitle(data.metaTitle || "");
        setItems(Array.isArray(data.items) ? data.items : []);
        setHeaderTexts(Array.isArray(data.headerTexts) ? data.headerTexts : []);
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return {
    title,
    description,
    metaTitle,
    items,
    headerTexts,
    currentLanguage,
    changeLanguage,
  };
}
